import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProjectCard from './ProjectCard';
import Particle from '../Particle';
import KnittX from '../../assets/Projects/KnittX.png';
import AsthaTrade from '../../assets/Projects/AsthaTrade.png';
import GlobeX from '../../assets/Projects/GlobeX.png';
import PersonalPortfolio from '../../assets/Projects/PersonalPortfolio.png';
import FacebookGif from '../../assets/Projects/FacebookGif.png';

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="sub-heading">
          My <strong className="text-color">Works </strong>
        </h1>
        <p style={{ color: 'white' }}>Here are a few projects I've worked.</p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={KnittX}
              title="Knittx"
              description="Textile Management App build with React, NodeJS, MongoDB, AntDesign, TailwindCSS and Firebase. It helps textiles companies to create customers, generate invoices and delivery challans."
              ghLink="https://github.com/Vasanth1009/KnittX"
              demoLink="https://knittx.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={PersonalPortfolio}
              title="Personal Portfolio"
              description="My first portfolio build with HTML, CSS, Javascript."
              ghLink="https://github.com/Vasanth1009/Personal-Portfolio"
              demoLink="https://vasanth1009.github.io/Personal-Portfolio/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={FacebookGif}
              title="Facebook Post Clone with GIF"
              description="Clone of Facebook feed page build with React, TailwindCSS. Able to create new post with GIF."
              ghLink="https://github.com/Vasanth1009/Facebook-Post-GIF"
              demoLink="https://facebook-post-gif.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AsthaTrade}
              title="AsthaTrade"
              description="Created a end to end design website build only with React, AntDesign."
              ghLink="https://github.com/Vasanth1009/AsthaTrade"
              demoLink="https://asthatrade.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={GlobeX}
              title="GlobeX"
              description="Webpage word counter build with React, NodeJS, MongoDB, AntDesign, Tailwind and Firebase. It will find the total number of words in a website."
              ghLink="https://github.com/Vasanth1009/GlobeX"
              demoLink="https://globex-app.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Projects;
